import illustrationDashboard from "assets/illustrations/illustration_dashboard.png";
import bgLogin from "assets/background/banner_app_light.png";
import bgLoginDark from "assets/background/banner_app_dark.png";
// background Overlay
import overlay2 from "assets/background/overlay_2.jpg";
import bgTransparent from "assets/background/transparent.png";
import character6 from "assets/illustrations/character_6.png";
import logoPrint from "assets/images/logo-print.png";
import logoPrintGrey from "assets/images/logo-print-grey.png";
const Images = {
  illustrationDashboard,
  bgLogin,
  bgLoginDark,
  background: {
    overlay2,
    bgTransparent,
  },
  character: {
    character6,
  },
  logoPrint,
  logoPrintGrey,
};
export default Images;
